import React from "react";
import { getDiscountPercentage } from "../../utills/CommonData";

const ProductDescription = ({ data }) => {
  const { name, price, features, product_description, specifications } = data;

  return (
    <div className="flex flex-col sm:gap-5 gap-3 ">
      <h1 className="sm:text-2xl text-xl">{name}</h1>
      {price.actual_price > 0 && (
        <p className="-my-3 sm:text-sm text-xs">Offer price</p>
      )}
      {price.offer_price > 0 && (
        <div className="flex sm:gap-5 gap-3 items-center ">
          <h2 className="sm:text-3xl text-xl font-semibold">
            {" "}
            ₹ {Number(price.offer_price).toLocaleString("en-IN")}
          </h2>
          <h2 className="sm:text-sm text-xs text-light line-through">
            {" "}
            ₹{Number(price.actual_price).toLocaleString("en-IN")}
          </h2>
          <h3 className="text-success font-semibold">
            {getDiscountPercentage(price.actual_price, price.offer_price) +
              "% off"}
          </h3>
        </div>
      )}
      {/* Product Features */}

      <div>
        <h3 className="sm:text-xl text-base sm:pb-5 pb-3 ">Features</h3>
        {features &&
          features.length > 0 &&
          features?.map((feature, index) => (
            <ul
              key={index}
              className="sm:text-sm text-xs text-light list-disc pl-5 flex flex-col"
            >
              <li className="text-dark sm:pb-3 pb-1">{feature}</li>
            </ul>
          ))}
      </div>

      {/* About this item */}

      <div>
        <h3 className="sm:text-xl text-base sm:pb-5 pb-3 ">About this item</h3>
        {product_description &&
          product_description.length > 0 &&
          product_description?.map((item) => {
            const { id, description } = item;
            return (
              <ul
                key={id}
                className="sm:text-sm text-xs text-light list-disc pl-5 flex flex-col"
              >
                <li className="text-dark sm:pb-3 pb-1">{description}</li>
              </ul>
            );
          })}
      </div>

      {/* Product specifications */}

      <div>
        <h3 className="sm:text-xl text-base sm:pb-5 pb-3 ">Specifications</h3>
        {specifications && Object.keys(specifications).length > 0 ? (
          <ul className="sm:text-sm text-xs text-light list-disc pl-5 flex flex-col">
            {Object.entries(specifications).map(([key, value], index) => (
              <li key={index} className="text-dark sm:pb-3 pb-1">
                <span className="font-semibold capitalize">{key}: </span>
                {value}
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-light">No specifications available</p>
        )}
      </div>
    </div>
  );
};

export default ProductDescription;
